import React from "react";
import { Router } from "@reach/router";
import Navbar from "../components/App/Navbar";
import Footer from "../components/App/Footer";
import Legals from "../components/App/Legals";
import Layout from "../components/App/Layout";
import ConsoleBackground from "../components/App/Background";
import PageBanner from "../components/Common/AdminWelcomebanner";
import ProfileHome from "../components/Profile/ProfileHome";
import ProfileCredentials from "../components/Profile/ProfileCredentials";
import ProfileMFA from "../components/Profile/ProfileMFA";
import AdminContainer from "../components/Common/AdminContainer";
import PrivateRoute from "../components/Common/privateRoute";

const Profile = () => (
  <ConsoleBackground>
    <Layout>
      <Navbar />
      
      <AdminContainer>
       <PageBanner/>
      </AdminContainer>
      <Footer />
      <Legals />
    </Layout>
  </ConsoleBackground>
);

export default Profile;
